export const WEB_PATH = '';

//export const API_PATH = 'http://service.solarbank.com.tw/api';
export const API_PATH = process.env.REACT_APP_APIROOT;

export const ACTIVE_TIME = {
    start_hour: 7,
    start_minute: 0,
    end_hour: 18,
    end_minute: 0,
}

